import { render, staticRenderFns } from "./shopping-cart-empty.vue?vue&type=template&id=3fc83f92&scoped=true&"
import script from "./shopping-cart-empty.vue?vue&type=script&lang=ts&"
export * from "./shopping-cart-empty.vue?vue&type=script&lang=ts&"
import style0 from "./shopping-cart-empty.vue?vue&type=style&index=0&id=3fc83f92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc83f92",
  null
  
)

export default component.exports